(function() {
  'use strict';

  const COOKIE_NAME = 'ls';
  const COOKIE_EXPIRY_DAYS = 1;
  const QUERY_PARAM_KEY = 'ls';

  /**
   * Get the secret link value from theme settings
   */
  function getSecretLinkValue() {
    return (window.theme && window.theme.settings && window.theme.settings.secretLinkValue) || '';
  }

  /**
   * Get query parameter from URL
   */
  function getQueryParam(name) {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(name);
  }

  /**
   * Set cookie with expiry
   */
  function setCookie(name, value, days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    const expires = `expires=${date.toUTCString()}`;
    document.cookie = `${name}=${value};${expires};path=/`;
  }

  /**
   * Get cookie value
   */
  function getCookie(name) {
    const nameEQ = name + '=';
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

  /**
   * Get product handle from current URL
   */
  function getProductHandle(targetElement) {
    return targetElement.dataset.productHandle;
  }

  /**
   * Fetch product-form section and replace content
   */
  async function fetchAndReplaceProductForm() {
    const targetElements = document.querySelectorAll('[data-allow-show-b2c]');
      if (!targetElements) return;

      for (const targetElement of targetElements) {
        const productHandle = getProductHandle(targetElement);

        if (!productHandle) {
          console.warn('Could not determine product handle from URL');
          continue;
        }

      try {
        // Use the product URL with sections parameter (Shopify pattern)
        const productUrl = `/products/${productHandle}`;
        let sectionUrl;
        if (targetElement.dataset.allowShowB2c === 'form') {
          sectionUrl = `${productUrl}?sections=product-form`;
        } else if (targetElement.dataset.allowShowB2c === 'price') {
          sectionUrl = `${productUrl}?sections=product-price`;
          // important needed to overrwite some css that was added by client
          targetElement.parentNode.style = 'display: flex !important';
        }

        const response = await fetch(sectionUrl);
        if (!response.ok) {
          throw new Error(`Failed to fetch section: ${response.status}`);
        }

        const data = await response.json();
        // The response is JSON with section name as key
        let sectionHtml = data['product-form'];
        if (targetElement.dataset.allowShowB2c === 'price') {
          sectionHtml = data['product-price'];
        }
        if (!sectionHtml) {
          throw new Error('Section HTML not found in response');
        }

        // Parse the HTML response
        const parser = new DOMParser();
        const doc = parser.parseFromString(sectionHtml, 'text/html');

        // Get the inner content - sections are typically wrapped in a div with class 'shopify-section'
        const sectionElement = doc.querySelector('.shopify-section') || doc.body.firstElementChild || doc.body;

        // Replace the content within [data-allow-show-b2c]
        targetElement.innerHTML = sectionElement.innerHTML;

        // Reinitialize any scripts that might be needed
        if (targetElement.dataset.allowShowB2c === 'form') {
          // Reinitialize product-form custom element if it exists
          const productFormElement = targetElement.querySelector('product-form');
          if (productFormElement && customElements.get('product-form')) {
            // Trigger initialization if needed
            if (productFormElement.init) {
              productFormElement.init();
            }
          }
        }

        // Dispatch event to allow other scripts to react to the content change
        document.dispatchEvent(new CustomEvent('shopify:section:load', {
          detail: { target: targetElement }
        }));

      } catch (error) {
        console.error('Error fetching product-form section:', error);
      }
    }
  }

  /**
   * Initialize the functionality
   */
  function init() {
    // Get the secret link value from theme settings
    const secretLinkValue = getSecretLinkValue();

    // Check if URL has 'ls' query parameter with the matching value
    const lsParam = getQueryParam(QUERY_PARAM_KEY);

    // If a secret value is configured, check if it matches
    // If no secret value is configured, any value in 'ls' will work
    if (lsParam !== null) {
      if (secretLinkValue === '' || lsParam === secretLinkValue) {
        // Set cookie with 1 day expiry
        setCookie(COOKIE_NAME, '1', COOKIE_EXPIRY_DAYS);
      }
    }

    // Check if cookie exists and [data-allow-show-b2c] element exists
    const cookieExists = getCookie(COOKIE_NAME) !== null;
    const targetElement = document.querySelector('[data-allow-show-b2c]');

    if (cookieExists && targetElement) {
      // Fetch and replace content
      fetchAndReplaceProductForm();
    }
    if (cookieExists) {
      const cartIcon = document.querySelector('#cart-icon');
      if (cartIcon) {
        cartIcon.style.display = 'block';
      }
    }
  }

  // Run on DOMContentLoaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

